// CacheKey c43291a807a7a24f56111c8f7560bcbd
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-SUFFOLK_CARE_COLLABORATIVE": {
    simple_form: {
      labels: {
        encounter: {
          arrival_date: "Survey Date",
          encounter_id: "Unique Insignia ID",
          facility: "Agency",
          unit: "Participant List",
          unit_id: "Participant List",
          unit_name: "Participant List"
        },
        patient: {
          encounter_id: "Unique Insignia ID",
          unit_name: "Participant List",
          test_patient: "Test Participant?"
        },
        unit: {
          facility: "Agency"
        }
      }
    }
  }
}

